(ns app.front.view.pre-consultation-meetings.subs
  (:require [app.domain.meeting.model :as meeting-model]
            [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::meetings
  :<- [::entities/entities {:domain/state :meeting.state/published}]
  :-> (partial filter meeting-model/valid-pre-con-meeting?))
